import { render } from "./NewsContent.vue?vue&type=template&id=33c93f2a"
import script from "./NewsContent.vue?vue&type=script&lang=js"
export * from "./NewsContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__